import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export const initialState = {
  allClips: [],
  clips: [],
  autoClips: [],
};

export default {
  state: () => ({...initialState}),
  mutations,
  actions,
  getters,
};
